export enum SubdivisionOverrideTypeEnum {
  OFFSET = 'Offset',
  FIXED = 'Fixed',
}
